import React from 'react';
import { motion } from 'framer-motion';
import { FiUser, FiUsers } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const GameModeSelector = ({ onSelect }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="max-w-4xl mx-auto px-6 grid md:grid-cols-2 gap-6"
    >
      <button 
        onClick={() => onSelect('solo')}
        className="group relative bg-white border-2 border-slate-200 p-8 rounded-[2.5rem] text-left hover:border-indigo-300 transition-all hover:shadow-xl hover:shadow-indigo-50"
      >
        <div className="w-14 h-14 bg-slate-50 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-indigo-50 transition-colors">
          <SafeIcon icon={FiUser} className="w-7 h-7 text-slate-400 group-hover:text-indigo-600" />
        </div>
        <h3 className="text-2xl font-black text-slate-900 mb-2">Solo Explorer</h3>
        <p className="text-slate-500 font-medium">Challenge yourself to break the ice with new people around you.</p>
      </button>

      <button 
        onClick={() => onSelect('duo')}
        className="group relative bg-slate-900 p-8 rounded-[2.5rem] text-left hover:shadow-2xl hover:shadow-indigo-200 transition-all border-2 border-slate-900"
      >
        <div className="absolute top-6 right-6">
          <span className="bg-indigo-500 text-white text-[10px] font-black px-3 py-1 rounded-full uppercase tracking-widest animate-pulse">
            Recommended
          </span>
        </div>
        <div className="w-14 h-14 bg-white/10 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-indigo-500/20 transition-colors">
          <SafeIcon icon={FiUsers} className="w-7 h-7 text-indigo-400 group-hover:text-indigo-300" />
        </div>
        <h3 className="text-2xl font-black text-white mb-2">Duo Journey</h3>
        <p className="text-slate-400 font-medium">Play with a friend or partner on one device. Connect and level up together.</p>
      </button>
    </motion.div>
  );
};

export default GameModeSelector;